import React from 'react';

export default function Models(props) {
    return(
        <div className='model-container'>
            <img className='model-image' src={props.img} />
            <h1 className='model-title'>{props.title}</h1>
            <p className='model-description'>{props.description}</p>
            <a className='model-link' href={props.url} target='_blank'><button>Details</button></a>
            <p className='model-date'>Last updated: {props.date}</p>
        </div>
    )
}